import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import axios from 'axios';
import { ensureReportAuth } from './core/reportAuth'
import format from 'date-fns/format'
import addMonths from 'date-fns/add_months';
import addDays from 'date-fns/add_days';
import CryptoJS from "crypto-js";
import _ from 'lodash'
import { NOTIMP } from 'dns';
import { stat } from 'fs';
export default {
    namespaced: true,
    state: {
      selectTeam:'',
      teamsfixed: [],
      teamsall:[],
      teamsfixedall: [],
      teamsfixedall_temp: [],
      inputSearch: '',
      happyStatus:[],
      happyStatuspercent:0,
      feedback: {openEndedFeedback:0,past_openEndedFeedback:0,compare:0},
      managerRate:0,
      participationRate:{participationRate:0,compare:0},
      award:{WHO_5:0,eRes:0,Culture:0,NPS:0,eNPS:0},
      standardAward:{
        NPS:{gold:70,platinum:80,ultra_platinum:90},
        eNPS:{gold:40,platinum:55,ultra_platinum:70},
        WHO_5:{gold:70,platinum:80,ultra_platinum:90},
        feedback:{gold:50,platinum:65,ultra_platinum:75},
        participation:{gold:70,platinum:80,ultra_platinum:90},
        debi:{gold:50,platinum:60,ultra_platinum:75},
        proactivity:{gold:60,platinum:75,ultra_platinum:90},},
      eNPS:'',
      NPS:'',
      percentileRank:{managerRate:0,participationRate:0,feedback:0},
      loading: true,
      loadingAward: true,
      debi:{debi:0}
    },
    mutations: {
        setTeamHeight(state:any, result:any) {
            state.selectTeam = result
        },
        sethappyStatus(state:any, result:any) {
            state.happyStatus = result
        },
        sethappyStatuspercent(state:any, result:any) {
            state.happyStatuspercent = result
        },
        setfeedback(state:any, result:any) {
            state.feedback = result
        },
        setmanagerRate(state:any, result:any) {
            state.managerRate = result
        },
        setparticipationRate(state:any,result:any) {
            state.participationRate = result
        },
        setAward(state:any, result:any) {
            state.award = result
        },
        setpercentileRank(state:any, result:any) {
            state.percentileRank = result
        },
        setdebi(state:any, result:any) {
            state.debi = result
        }
    },
    actions: {
        async login({commit,state}:any, obj:any){
            state.loading = true
            console.log('No user is signed in.')
            await ensureReportAuth().then(async (res) => {
            })
        },
        async getmostTopTeam({commit,state,dispatch}:any, obj:any){
            state.loading = true
           // console.log('obj',obj)
            let topmostArr: Array<any> = [];
            let selectTeam=''
            const team= (await firebase.database().ref('team').orderByChild("company").equalTo(obj.comp_id).once('value')).val()
            const company = (await firebase.database().ref(`company/${obj.comp_id}`).once('value')).val()
            firebase.database().ref().child('standard_award').once('value', (snapshot) => {
                
                    var _data  = snapshot.val();
                    
                    state.standardAward=
                    {
                        NPS:{gold:_data.NPS.gold,platinum:_data.NPS.platinum,ultra_platinum:_data.NPS.ultra_platinum},
                        eNPS:{gold:_data.eNPS.gold,platinum:_data.eNPS.platinum,ultra_platinum:_data.eNPS.ultra_platinum},
                        WHO_5:{gold:_data.WHO_5.gold,platinum:_data.WHO_5.platinum,ultra_platinum:_data.WHO_5.ultra_platinum},
                        feedback:{gold:_data.feedback.gold,platinum:_data.feedback.platinum,ultra_platinum:_data.feedback.ultra_platinum},
                        participation:{gold:_data.participation.gold,platinum:_data.participation.platinum,ultra_platinum:_data.participation.ultra_platinum},
                        debi:{gold:_data.DEBI.gold,platinum:_data.DEBI.platinum,ultra_platinum:_data.DEBI.ultra_platinum},
                        proactivity:{gold:_data.proactivity.gold,platinum:_data.proactivity.platinum,ultra_platinum:_data.proactivity.ultra_platinum},
                    }
                
            })
            

            firebase.database().ref('questions').orderByChild('report_card').equalTo('Y').once('value', snapshot => {
                snapshot.forEach((doc): any => {
                    const data = doc.val()
                    data.key = doc.key
                    if(data.company == 'main' || data.company == obj.comp_id){
                        if(data.nps !== undefined){
                            
                            if(data.nps == 'eNPS'){
                                state.eNPS = data.key
                            }else{
                                state.NPS = data.key
                            }
                            
                        }

                    }
                    })
                })

            _.forEach(team, (value,index)=> {

                    if(value.parent == ''){
                        topmostArr.push(index)
                    }
            });
           
                selectTeam = topmostArr[0]
                if(topmostArr.length > 1){
                    selectTeam = _.find(topmostArr, (value) => {
                        const chk_topmost = _.find(team, { parent: value });
                         return !!chk_topmost;
                         });
                }
                
               commit('setTeamHeight', selectTeam)
               await dispatch('getHappyStatus', obj)
               dispatch('getData', obj)
                dispatch('getAward', obj)
        },
        async getHappyStatus({commit,state}:any, obj:any){
        state.loading = true
        let active = {};
        const insight_teams: Array<any> = [];
        const selectTeam = state.selectTeam

        await (async (): Promise<any> => {
            // PG read API (active_users_teams mirror), self-scoped by the caller's Firebase
            // token (per-company). Firestore fallback on error.
            const from = format(addMonths(new Date(), -6), 'YYYY-MM-DD');
            const to = format(new Date(), 'YYYY-MM-DD');
            try {
                const cu = firebase.auth().currentUser;
                if (cu) {
                    const idToken = await cu.getIdToken();
                    const r = await axios.get('https://us-central1-people2-admin.cloudfunctions.net/activeUsersReadApi/teams', {
                        params: { team: selectTeam, from, to },
                        headers: { Authorization: `Bearer ${idToken}` },
                        timeout: 15000,
                    });
                    const days = (r.data && r.data.days) || [];
                    return { forEach: (cb: any) => days.forEach((d: any) => cb({ data: () => ({ date: d.date, usersActive: d.usersActive, usersTotal: d.usersTotal, users: d.users || [] }) })) };
                }
            } catch (e) { /* fall through to Firestore */ }
            return firebase.firestore().collection('active_users_teams').where("date", ">=", from).where('team','==',selectTeam).where('company','==',obj.comp_id).get();
        })().then((querySnapshot)=> {
            querySnapshot.forEach((doc)=> {
                if(!active[doc.data().date]){
                    active[doc.data().date] = {};
                }
                active[doc.data().date] = doc.data();
            });
        });
        
        await firebase.firestore().collection('insight_teams').where("quest_id", "==", '-Kgs61AHOnpJ3rfyQr6t').where("team", "==", selectTeam).where("date", ">=", format(addMonths(new Date(), -5), 'YYYY-MM-DD')).where("date", "<=", format(new Date(), 'YYYY-MM-DD')).orderBy('date', 'desc').get()
          .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
                const insight_team = doc.data()
                insight_team.key = doc.id
                const date_weekend= format(new Date(insight_team.date), 'EEEEEE')
                if(date_weekend!=='Sa'&&date_weekend!=='Su'){
                   
                    insight_teams.push(insight_team)
                }
             });
             //console.log('insight_teams.slice(0, 90)',insight_teams.slice(0, 90).reverse())
                let sum=0
                let happyrate=0
                let total_num_responses=0
                for(let i in insight_teams.slice(0, 90)){
                    const activeData = active[insight_teams[i].date];
                    const usersActive = activeData ? activeData.usersActive : 0;
                    happyrate = isNaN(insight_teams[i].happy_percent * usersActive) ? 0 : insight_teams[i].happy_percent * usersActive;
                    total_num_responses += usersActive;
                    sum += happyrate;
                }
        
            commit('sethappyStatuspercent', isNaN(sum/total_num_responses)?0:(sum/total_num_responses).toFixed())
            commit('sethappyStatus', insight_teams.slice(0, 90).reverse())
            });
    
        },
        async getData({commit,state,dispatch}:any, obj:any){
            let managerRate=0
            let openEndedFeedback=0
            let participationRate=0
            let _managerRate:any=0
            let _openEndedFeedback:any=0
            let _participationRate:any=0
            let managerRateArr:Array<any>=[]
            let debi=0
            let openEndedFeedbackArr:Array<any>=[]
            let participationRateArr:Array<any>=[]
            const date= format(addDays(new Date(), -1), 'YYYY-MM-DD')
            const _date= format(addDays(new Date(), -91), 'YYYY-MM-DD')
            await firebase.firestore().collection('company_health_status').where("date", "==",date).get()
            .then(async (querySnapshot) => {
                querySnapshot.forEach((doc) => {
                const data=doc.data()           
                managerRateArr.push(data.manager_rate)
                openEndedFeedbackArr.push(data.feedback_rate)
                participationRateArr.push(data.participation_rate)
                if(data.company_id == obj.comp_id){
                    managerRate=data.manager_rate
                    openEndedFeedback=data.feedback_rate
                    participationRate=data.participation_rate
                    debi=data.debi?data.debi:0
                }
                
                })
                const percentileRankManager=await dispatch('calculatePercentileRank', {scores:managerRateArr, score:managerRate}) 
                // console.log('percentileRankManager',percentileRankManager)
                const percentileRankFeedback=await dispatch('calculatePercentileRank', {scores:openEndedFeedbackArr, score:openEndedFeedback}) 
                // console.log('percentileRankFeedback',percentileRankFeedback)
                const percentileRankparticipation=await dispatch('calculatePercentileRank', {scores:participationRateArr, score:participationRate}) 
                // console.log('percentileRankparticipation',percentileRankparticipation)
                commit('setpercentileRank', {managerRate:percentileRankManager.toFixed(),participationRate:percentileRankparticipation.toFixed(),feedback:percentileRankFeedback.toFixed()})
            })
            await firebase.firestore().collection(`company_health_status`).doc(`${obj.comp_id}-${_date}`).get()
            .then((docSnap) => {
               
                if (docSnap.exists) {
                    // console.log("Document data:", docSnap.data());
                    const data=docSnap.data()
                    if(data){
                        _managerRate=data.manager_rate
                        _openEndedFeedback=data.feedback_rate
                        _participationRate=data.participation_rate
                    }
                    
                  }
            })

            state.loading = false
            commit('setparticipationRate', {participationRate:participationRate,compare:participationRate-_participationRate})
            commit('setfeedback', {openEndedFeedback:openEndedFeedback,past_openEndedFeedback:_openEndedFeedback,compare:isNaN(openEndedFeedback-_openEndedFeedback)?0:Math.round(openEndedFeedback-_openEndedFeedback)})
            commit('setdebi', {debi:debi})
            commit('setmanagerRate', {managerRate:managerRate,compare:isNaN(managerRate-_managerRate)?0:Math.round(managerRate-_managerRate)})
        },
        async getAward({commit,state}:any, obj:any){
            state.loadingAward = true
            let proactivity:any=0
            const awardData={WHO_5:0,eRes:0,Culture:0,NPS:0,eNPS:0,proactivity:0}
            firebase.firestore().collection('proactivity_psychological_rating').where("key", "==",obj.comp_id+"_"+state.selectTeam).get()
                .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    const data=doc.data()
                        proactivity=data.proactivity
    
                    })
                    
    
                })



            
            const questionSet1={ // WHO-5
                1:'-MdMv_XgThL0o2iunlhE',
                2:'-MdMw8kfpZtxnppGUA1f',
                3:'-MdMyavdF-YvuyzW6cA5',
                4:'-MdMz-TodEXbj3AC68oP',
                5:'-MdMzwfySVTjhOAGoxTP'
            }
         
            let datalistall:Array<any>=[]
            firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==",obj.comp_id).where("team", "==", state.selectTeam).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    datalistall.push(data)
                    
                });
                //WHO-5
                let overAll = 0;
                let dataTeamSelect: Array<any> = [];
                let dataSum:any = 0;
                let maxmimum:any = 0;
                             
                    dataTeamSelect.push(_.filter(datalistall, { 'quest_id': questionSet1[1] }))
                    dataTeamSelect.push(_.filter(datalistall, { 'quest_id': questionSet1[2] }))
                    dataTeamSelect.push(_.filter(datalistall, { 'quest_id': questionSet1[3] }))
                    dataTeamSelect.push(_.filter(datalistall, { 'quest_id': questionSet1[4] }))
                    dataTeamSelect.push(_.filter(datalistall, { 'quest_id': questionSet1[5] }))
                    
                        if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                            for(let x=0; x<5; x++){
                                if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                    for(let y=0; y<6; y++){
                                        if(dataTeamSelect[x][0].answer[y]){
                                            dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                            }
                                        }
                                    }
                                }
                                 let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                 total = total * 1
                                 overAll = total
                            }else{
                                 overAll = -999;
                            }
                    awardData.WHO_5 = overAll



  

            //NPS
            dataTeamSelect = _.filter(datalistall, {  'quest_id': state.NPS })
           

            if(dataTeamSelect[0] && dataTeamSelect[0].answer && Object.keys(dataTeamSelect[0].answer).length > 0){
                let promotors:any = 0
                let detractors:any = 0
                let nps_score:any = 0
                _.forEach(dataTeamSelect[0].answer, function (value, key:number) {
                    if(key >= 0 && key <= 6){
                        detractors+= value
                    }else if(key >=9 && key <= 10){
                        promotors+= value
                    }
                });
                nps_score = ((promotors / Number(dataTeamSelect[0].total)) - (detractors / Number(dataTeamSelect[0].total)))*100
                let total:any =Number(Math.round(nps_score))
                overAll = total
                
            }
            awardData.NPS = overAll

            //eNPS
            dataTeamSelect = _.filter(datalistall, {  'quest_id': state.eNPS })


            if(dataTeamSelect[0] && dataTeamSelect[0].answer && Object.keys(dataTeamSelect[0].answer).length > 0){
                let promotors:any = 0
                let detractors:any = 0
                let nps_score:any = 0
                _.forEach(dataTeamSelect[0].answer, function (value, key:number) {
                    if(key >= 0 && key <= 6){
                        detractors+= value
                    }else if(key >=9 && key <= 10){
                        promotors+= value
                    }
                });
                nps_score = ((promotors / Number(dataTeamSelect[0].total)) - (detractors / Number(dataTeamSelect[0].total)))*100
                let total:any =Number(Math.round(nps_score))
                overAll = total
      
            }
            awardData.eNPS = overAll
            awardData.proactivity = proactivity
            state.loadingAward = false
            commit('setAward', awardData)
            })
        },
        calculatePercentileRank({commit,state}:any, obj:any) {
            const scores=obj.scores
            const score=obj.score
            // console.log('scores',scores)
            // Sort the scores array
            scores.sort((a, b) => a - b);
        
            // Count the number of scores less than the given score
            let count = 0;
            for (let i = 0; i < scores.length; i++) {
                if (scores[i] < score) {
                    count++;
                } else {
                    break; // Since the array is sorted, we can stop counting once we reach a score >= the given score
                }
            }
        
            // Calculate the percentile rank
            let percentileRank = (count / scores.length) * 100;
        
            return percentileRank;
        },
        async genlink({commit,state}:any, obj:any){
            console.log('genlink')
            const company = (await firebase.database().ref(`/company`).orderByChild('status').equalTo('Y').once('value')).val();
            for(const i in company){
                const ciphertext = CryptoJS.AES.encrypt(i+'||'+company[i].name, 'company-health-status').toString();
                const url = 'https://insights.happily.ai/company-health-status/'+encodeURIComponent(ciphertext);
                console.log(company[i].name,"===",url)
                
            }
            
        }

    },
    getters: {
        managerRate: (state:any) => {
            return state.managerRate
        },
        happyStatus: (state:any) => {
            return state.happyStatus
        },
        happyStatuspercent: (state:any) => {
            return state.happyStatuspercent
        },
        feedback : (state:any) => {
            return state.feedback
        },
        participationRate : (state:any) => {
            return state.participationRate
        },
        inputSearch: (state:any) => {
            return state.inputSearch
        },
        award: (state:any) => {
            return state.award
        },
        standardAward: (state:any) => {
            return state.standardAward
        },
        percentileRank: (state:any) => {
            return state.percentileRank
        },
        loading: (state:any) => {
            return state.loading
        },
        loadingAward: (state:any) => {
            return state.loadingAward
        },
        debi: (state:any) => {
            return state.debi
        }
    }
  }